const memory = {}

export const get = <T>(key: string, defaultValue: Nullable<T> = null): T => {
  return memory[key] || defaultValue
}

export const set = (key: string, value: any): void => {
  return (memory[key] = value)
}
